import React from "react"

import ContactForm from "@components/ContactForm/ContactForm"
import { SEO } from "@components/SEO/SEO"
import Layout from "@components/Layout/Layout"

function Contact ({ data })
{
  return (
    <div>
      <Layout lang="en" dropdownId="contact">
        <div className="mx-auto mt-28 max-w-7xl px-4 sm:px-6 lg:mt-24 lg:px-8">
          <ContactForm lang="en" >
            <div className="mb-7">
              <h1 className="mb-3">A project in the offing?</h1>
              <p>
                Don’t hesitate to contact us for any information. We are here to
                help.
              </p>
            </div>
          </ContactForm>
        </div>
      </Layout>
    </div>
  )
}

export default Contact

export const Head = ({ location, params, data, pageContext }) =>
{
  return (
    <SEO
      title="Contact our customer relations department | FEHR Group"
      description="A question ? A project in mind ? Don t hesitate to contact us. We are here to help. Mail. Phone or Chat."
      // lang="en"
      pathname={location.pathname}
    />
  )
}
